export default "__VITE_ASSET__BeAd3DaL__"